import * as XLSX from 'xlsx';

import { ShamirRXInputRow } from '../../types';
import { getCellValue, } from '../../utils';

const HEADER_LABEL = 'Part Number';
const BUY_PRICE_START_INDEX = 3;
const BUY_PRICE_END_INDEX = 19;
const SELL_PRICE_OFFSET = 17;

const isValidCoatingPrice = (value: unknown) => {
    if (value === '' || value === 'BRAK') {
        return false;
    }

    return !Number.isNaN(Number(value));
};

export const parseShamirRXExcel = (file: ArrayBuffer): ShamirRXInputRow[] => {
    const workbook = XLSX.read(file, { type: 'array' });
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const rows = XLSX.utils.sheet_to_json<unknown[]>(worksheet, { header: 1, defval: '' });
    const headerRow = rows.find((row) => String(getCellValue(row, 0)).trim() === HEADER_LABEL);

    if (!headerRow) {
        throw new Error('Nie znaleziono nagłówków w pliku RX.');
    }

    const headerRowIndex = rows.indexOf(headerRow);
    const coatingNames = headerRow.slice(BUY_PRICE_START_INDEX, BUY_PRICE_END_INDEX + 1).map((name) => String(name).trim());
    const parsedRows: ShamirRXInputRow[] = [];

    for (const row of rows.slice(headerRowIndex + 1)) {
        const catalogNumber = String(getCellValue(row, 0)).trim();
        const description = String(getCellValue(row, 1)).trim();

        if (!catalogNumber || !description) {
            continue;
        }

        for (let index = 0; index < coatingNames.length; index += 1) {
            const buyPriceIndex = BUY_PRICE_START_INDEX + index;
            const sellPriceIndex = buyPriceIndex + SELL_PRICE_OFFSET;
            const buyPriceValue = getCellValue(row, buyPriceIndex);

            if (!isValidCoatingPrice(buyPriceValue)) {
                continue;
            }

            parsedRows.push({
                catalogNumber,
                description,
                materialCode: String(getCellValue(row, 2)).trim(),
                coating: coatingNames[index],
                buyPrice: Number(buyPriceValue),
                sellPrice: Number(getCellValue(row, sellPriceIndex)),
            });
        }
    }

    return parsedRows;
};
